import React, { useLayoutEffect } from 'react';
import styles from './style.module.scss';
import { Card, Col, Row, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import useBreadcrumb from 'hooks/useBreadcrumb';
import Filters from 'components/filters';
import useTeam from '../useTeam';
import { Route, Routes } from 'react-router-dom';
import DeleteModal from '../../../../components/deleteModalView';
import ViewModal from './viewModal';

const UsersList = () => {
  const { t } = useTranslation();
  const { addNewBreadcrumb, removeLastBreadcrumb } = useBreadcrumb();
  const {
    filters,
    columns,
    data,
    loading,
    onChangeTableFilter,
    updateInProcess,
    onDelete,
    singleItem,
  } = useTeam({ isCustomers: true });

  useLayoutEffect(() => {
    removeLastBreadcrumb('/team/list');
    addNewBreadcrumb(t('Il tuo team'), '/team/list');
    return () => {
      removeLastBreadcrumb('/team/list');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card className={styles.card} title={t('Gestione utenti')}>
      <Row>
        <Col span={24}>
          <Filters filters={filters} />
        </Col>
        <Col span={24}>
          <br />
          <Table
            bordered
            dataSource={data.users}
            pagination={data.pagination}
            onChange={onChangeTableFilter}
            columns={columns}
            scroll={{ x: 1500, y: 400 }}
            loading={loading}
          />
        </Col>
      </Row>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
        <Route
          path={':id/view'}
          element={<ViewModal singleItem={singleItem} />}
        />
      </Routes>
    </Card>
  );
};

export default UsersList;
